module.exports = __webpack_public_path__ + "img/ringsWithDifferentAlloys.69402e1.png";